import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import { Button, Text, Panel, Switch, H3, H4, Fieldset, FormGroup, Radio, Dropdown, Table, Box } from '@bigcommerce/big-design';
import { AddIcon, ArrowDropDownIcon, DeleteIcon, EditIcon } from '@bigcommerce/big-design-icons';

import { paymentMethodsIndex } from '../../redux/actions/paymentMethods';

const PaymentMethods = ({ payload, settings, submitSettings, loadPaymentMethods, paymentMethods, setShowNewPaymentMethodModal, setActivePaymentMethod, setShowEditPaymentMethodModal, setShowDisablePaymentMethodModal }) => {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    loadPaymentMethods(payload);
  }, []);

  const edit = (id) => {
    let activeMethod = paymentMethods.paymentMethods.find(method => method.id === id);
    setActivePaymentMethod(activeMethod);
    setShowEditPaymentMethodModal(true);
  }

  const disable = (id) => {
    let activeMethod = paymentMethods.paymentMethods.find(method => method.id === id);
    setActivePaymentMethod(activeMethod);
    setShowDisablePaymentMethodModal(true);
  }

  const setDropdownValue = (setField, value) => {
    setField(value);
  }

  const paymentMethodsItems = () => {
    let items = [];

    paymentMethods.paymentMethods.map(paymentMethod => 
      items.push(
        {
          content: paymentMethod.method_name,
          onItemClick: () => setDropdownValue(setActivePaymentMethod, paymentMethod),
          hash: paymentMethod.id
        }
      )
    )

    return items;
  }

  return(
    <Panel>
      <H3>Payment Methods</H3>
      { paymentMethods.status !== 'success' &&
        <LoadingSpinner statusText="Loading Payment Methods"/>
      }
      { paymentMethods.status === 'success' && paymentMethods.paymentMethods.length > 0 &&
        <>
          <Table
            columns={[
              { header: 'Name', hash: 'method_name', render: ({ method_name }) => method_name },
              { header: 'Actions', hash: 'id', render: ({ id }) => 
                <>
                  <Button
                    onClick={() => edit(id)}
                    variant="subtle"
                    iconLeft={<EditIcon />}
                  >
                    Edit
                  </Button> 
                  <Button 
                    onClick={() => disable(id)}
                    variant="subtle"
                    actionType="destructive"
                    iconLeft={<DeleteIcon />}
                  >
                    Disable
                  </Button> 
                </>
              },
            ]}
            items={paymentMethods.paymentMethods}
          />

          <Button
            iconLeft={<AddIcon />}
            onClick={() => setShowNewPaymentMethodModal(true)}
            variant="secondary"
          >
            New Payment Method
          </Button>
        </>
      }
      { paymentMethods.status === 'success' && paymentMethods.paymentMethods.length === 0 &&
        <Box
          backgroundColor="warning10"
          border="box"
          borderRadius="normal"
          padding="medium"
        >
          <div className="text-center">
            <Text>No payment methods set. Create payment methods to see them here.</Text>
            <Button
              iconLeft={<AddIcon />}
              onClick={() => setShowNewPaymentMethodModal(true)}
              variant="secondary"
            >
              New Payment Method
            </Button>
          </div>
        </Box>
      }
    </Panel>
  )
}

const mapStateToProps = state => ({
  settings: state.settings.settings,
  paymentMethods: state.paymentMethods,
});

const mapDispatchToProps = (dispatch) => ({
  submitSettings: (payload, newSettings) => dispatch(updateSettings(payload, newSettings)),
  loadPaymentMethods: (payload) => dispatch(paymentMethodsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethods);
